export class DsuManagerAssessmenModel {

    private onboardingid!: number;
    private dsumanagerName!: string;
    private declaration_date!: string;
    private is_completed!: boolean;
    private remarkContent!: string;
    private updatedbyrole!: string;
    private userRepCode!: string;
    private remarkId!: number;
    private rnfNo!: string;
    private rnfDate!: string;
    private lodgmentdate!: string;


    constructor() { }

    // Getters & Setters
    getOnboardingid(): number {
        return this.onboardingid;
    }
    setOnboardingid(onboardingid: number) {
        this.onboardingid = onboardingid;
    }

    getDsumanagerName(): string {
        return this.dsumanagerName;
    }
    setDsumanagerName(dsumanagerName: string) {
        this.dsumanagerName = dsumanagerName;
    }

    getDeclaration_date(): string {
        return this.declaration_date;
    }
    setDeclaration_date(declaration_date: string) {
        this.declaration_date = declaration_date;
    }

    getIs_completed(): boolean {
        return this.is_completed;
    }

    setIs_completed(is_completed: boolean) {
        this.is_completed = is_completed;
    }

    getRemarkContent(): string {
        return this.remarkContent;
    }
    setRemarkContent(remarkContent: string) {
        this.remarkContent = remarkContent;
    }

    getuserRepCode(): string {
        return this.userRepCode;
    }
    setuserRepCode(userRepCode: string) {
        this.userRepCode = userRepCode;
    }

    getrnfNo(): string {
        return this.rnfNo;
    }
    setrnfNo(rnfNo: string) {
        this.rnfNo = rnfNo;
    }

    getlodgmentdate(): string {
        return this.lodgmentdate;
    }
    setlodgmentdate(lodgmentdate: string) {
        this.lodgmentdate = lodgmentdate;
    }

    getrnfDate(): string {
        return this.rnfDate;
    }
    setrnfDate(rnfDate: string) {
        this.rnfDate = rnfDate;
    }

    getRemarkid(): number {
        return this.remarkId;
    }
    setRemarkid(remarkId: number) {
        this.remarkId = remarkId;
    }

    getupdatedbyrole(): string {
        return this.updatedbyrole;
    }
    setupdatedbyrole(updatedbyrole: string) {
        this.updatedbyrole = updatedbyrole;
    }



    toString() {
        return JSON.stringify({
            onboarding_id: this.getOnboardingid(),
            dsu_mgr_name: this.getDsumanagerName(),
            declaration_date: this.getDeclaration_date(),
            rnf_no: this.getrnfNo(),
            rnf_date: this.getrnfDate(),
            user_rep_code: this.getuserRepCode(),
            remark_id: this.getRemarkid(),
            is_completed: this.getIs_completed(),
            remarkContent: this.getRemarkContent(),
            updated_by_role: this.getupdatedbyrole()
        });
    }

    lodgetoString() {
        return JSON.stringify({
            id: this.getOnboardingid(),
            lodgmentDate: this.getlodgmentdate()
        });
    }

}
